import { Block } from 'webiq.boilerplate'

export default class NewMobileNav extends Block {
	static title = 'mobile-nav-new'

	init() {
		this.mobileNavToggleButton = this.getElement('toggle')
		this.mobileNavCloseButton = this.getElement('toggle--inner')

		this.mobileNavToggleButton.addEventListener('click', () => this.open())
		this.mobileNavCloseButton.addEventListener('click', () => this.close())
	}

	open() {
		this.addModifier('active')
	}

	close() {
		this.removeModifier('active')
	}
}
